{
  "allSldsNames": [
    "2DM1A.svg",
    "2IM.svg",
    "2IMT.svg",
    "2QM.svg",
    "BC.svg",
    "B_RU.svg",
    "C-left.svg",
    "C-right.svg",
    "C.svg",
    "CB-left.svg",
    "CB-right.svg",
    "CB.svg",
    "CBb-left.svg",
    "CBb-right.svg",
    "CBb.svg",
    "CC-left.svg",
    "CC-right.svg",
    "CM.svg",
    "D-left.svg",
    "D-right.svg",
    "D.svg",
    "D2S-left_RM6.svg",
    "D2S-right_RM6.svg",
    "DDM.svg",
    "DM1-S.svg",
    "DM1.svg",
    "DM1A.svg",
    "DM1D.svg",
    "DM1_A.svg",
    "DM1_W.svg",
    "DM2L.svg",
    "DM2R.svg",
    "DMVL-A.svg",
    "DMVL-S.svg",
    "D_NL.svg",
    "D_RM6.svg",
    "D_RU.svg",
    "FBMB1.svg",
    "GAM.svg",
    "GAM2.svg",
    "GBC-C.svg",
    "GBC-CC.svg",
    "GBC-I-left.svg",
    "GBC-I-right.svg",
    "GBC-I.svg",
    "GBCA-left.svg",
    "GBCA-right.svg",
    "GBCB.svg",
    "GBCE-left.svg",
    "GBCE-right.svg",
    "GBM-left.svg",
    "GBM-right.svg",
    "GBM.svg",
    "GIM.svg",
    "I-left.svg",
    "I-right.svg",
    "I.svg",
    "IM.svg",
    "IMB-left.svg",
    "IMB-right.svg",
    "IMB.svg",
    "IMT.svg",
    "I_FR.svg",
    "I_M3_RM6-right.svg",
    "I_M3_RM6.svg",
    "I_M_RM6-left.svg",
    "I_M_RM6-right.svg",
    "I_M_RM6.svg",
    "I_NL.svg",
    "I_RM6.svg",
    "I_RU.svg",
    "I_left_RM6.svg",
    "I_right_RM6.svg",
    "M1 IU-left.svg",
    "M1 IU-right.svg",
    "M1 IU.svg",
    "M1 UI-left.svg",
    "M1 UI-right.svg",
    "M1 UI.svg",
    "M2 IU-left.svg",
    "M2 IU-right.svg",
    "M2 IU.svg",
    "M2 UI-left.svg",
    "M2 UI-right.svg",
    "M2 UI.svg",
    "M3 IU-left.svg",
    "M3 IU-right.svg",
    "M3 IU.svg",
    "M3 UI-left.svg",
    "M3 UI-right.svg",
    "M3 UI.svg",
    "M4 IU-left.svg",
    "M4 IU-right.svg",
    "M4 IU.svg",
    "M4 UI-left.svg",
    "M4 UI-right.svg",
    "M4 UI.svg",
    "M5.svg",
    "MF.svg",
    "NSM.svg",
    "PM.svg",
    "PAIS-BBVT.svg",
    "PAIS-INCVT0.svg",
    "PAIS-INCVT1.svg",
    "PAIS-MF.svg",
    "PAIS-RSR.svg",
    "PAIS-TIE.svg",
    "PAIS-IN-TC.svg",
    "PAIS-IN-TC-ES.svg",
    "PAIS-IN-TC-TP.svg",
    "PAIS-IN-ES-TC-TP.svg",
    "PAIS-Fuse ES.svg",
    "PAIS-Fuse.svg",
    "PAIS-BC.svg",
    "PAIS-Riser Metering.svg",
    "PAIS-Riser.svg",
    "PAIS-Measurement.svg",
    "PAIS-CNT-TC.svg",
    "PAIS-CNT-ES-TC.svg",
    "PAIS-CNT-TC-TC.svg",
    "PAIS-CNT-ES-TC-TP.svg",
    "GBC-2C.svg",
    "GBC-D.svg",
    "Q-left.svg",
    "Q-right.svg",
    "Q.svg",
    "QM.svg",
    "QMC.svg",
    "Q_FR.svg",
    "Q_RM6.svg",
    "Q_left_RM6.svg",
    "Q_right_RM6.svg",
    "R-left.svg",
    "R-right.svg",
    "R.svg",
    "RE-left.svg",
    "RE-right.svg",
    "RE.svg",
    "RM AirSet-B Left.svg",
    "RM AirSet-B Right.svg",
    "RM AirSet-B.svg",
    "RM AirSet-I Left.svg",
    "RM AirSet-I Right.svg",
    "RM AirSet-I.svg",
    "RM AirSet-M1.svg",
    "RM AirSet-P Left.svg",
    "RM AirSet-P Right.svg",
    "RM AirSet-P.svg",
    "RM AirSet-Q Left.svg",
    "RM AirSet-Q Right.svg",
    "RM AirSet-Q.svg",
    "SM636-CM.svg",
    "SM636-DM1A.svg",
    "SM636-DM2.svg",
    "SM636-IM.svg",
    "SM636-PM.svg",
    "SM636-QM.svg",
    "Sb-left.svg",
    "Sb-right.svg",
    "Sb.svg",
    "T1-left.svg",
    "T1-right.svg",
    "T1.svg",
    "T2-left.svg",
    "T2-right.svg",
    "T2.svg",
    "TM.svg",
    "T_2_RM6.svg",
    "T_RM6.svg",
    "Transformer.svg",
    "Transformer_v2.svg"
  ]
}
